import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Button, Modal, ModalHeader, ModalBody, Alert, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classnames from 'classnames';
import CountUp from 'react-countup';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableContainer from '../../../Components/Common/TableContainer';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import DeleteModal from '../../../Components/Common/DeleteModal';
import Section from './Section';
import {Space} from "antd";

// Custom CSS
const customStyles = `
  .resource-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: -1.5rem;
  }
  .resource-header {
    background: linear-gradient(135deg, #2a4966 0%, #0ab39c 100%);
    color: #ffffff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1.5rem;
  }
  .resource-header h4 {
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
  }
  .resource-table th, .resource-table td {
    vertical-align: middle;
    padding: 0.75rem;
  }
  .resource-table tr:hover {
    background-color: #f1f5f7;
  }
  .resource-widget-card {
    transition: transform 0.3s ease;
  }
  .resource-widget-card:hover {
    transform: translateY(-5px);
  }
  .filter-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
  }
  .filter-container .form-control,
  .filter-container .form-select {
    border-radius: 4px;
    border: 1px solid #ced4da;
    min-width: 150px;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  .filter-container .form-control:focus,
  .filter-container .form-select:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0.2rem rgba(10, 179, 156, 0.25);
  }
  .action-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  .action-btn:hover {
    transform: translateY(-2px);
  }
  .new-badge {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    vertical-align: middle;
  }
  .dropdown-menu {
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
  }
  .dropdown-item {
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
    color: #2a4966;
  }
  .dropdown-item:hover {
    background-color: #f1f5f7;
    color: #0ab39c;
  }
  .dropdown-item i {
    margin-right: 0.5rem;
  }
  .resource-modal .modal-content {
    border-radius: 8px;
    border: none;
  }
  .resource-modal .modal-header {
    background: linear-gradient(135deg, #2a4966 0%, #0ab39c 100%);
    color: #ffffff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1.5rem;
  }
  .resource-modal .modal-header h5 {
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
  }
  .resource-modal .modal-body {
    padding: 1.5rem;
    background-color: #f9fafb;
  }
  .resource-modal .modal-body p {
    color: #333;
    font-size: 1rem;
    line-height: 1.6;
  }
  .resource-modal .modal-body strong {
    color: #2a4966;
  }
  @media (max-width: 768px) {
    .filter-container {
      flex-wrap: nowrap;
      overflow-x: auto;
    }
    .filter-container .form-control,
    .filter-container .form-select {
      min-width: 120px;
      font-size: 0.85rem;
    }
  }
`;

const ResourceList = () => {
    document.title = "Resource overview | Confidoo";

    return (
        <React.Fragment>
            <style>{customStyles}</style>
            <div className="page-content">
                <Container fluid style={{
                    padding:'50px 40px'
                }}>

<div
>
                        <BreadCrumb title="Resource overview" pageTitle="Resources" />
                        <Section  />

</div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ResourceList;